import React, { useState, useEffect } from "react";
import "./DeviceConfig.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getUserAddressRequest } from "../../../../store/GetUserAddress/getUserAddressSlice";
import AddAddress from "./AddAddress";
import { getLocalSessionData } from "../../../../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS } from "../../../../constants/AppConstants";
import { getDevicesRequest } from "../../../../store/brotherPlus/getDevices/getDevicesSlice";
import { updateEnrolledDeviceRequest } from "../../../../store/UserEnrolledDeviceDetails/UpdateUserEnrolledDeviceDetailsSlice";
import ErrorPage from "../../../../components/shared/errorPage/ErrorPage";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { routePath } from "../../../../constants/Routes";
import DeviceConnectedSuccessfullyImage from "../../../../assets/images/account-steps-completed-tick.svg";
import Loader from "../../../../components/shared/loader/Loader";
import { findValueByKey_From_ArrayOfObj, getCountryName, getDeviceInfoForAddNewDevice, truncateString } from "../../../../constants/AppMethod";
import DefaultPrinterImg from "../../../../assets/images/default-printer-img.png";
import useAddressValidation from '../../../../utils/CustomHooks/useAddressValidation';
import UsePostalCodeValidation from "../../../../utils/CustomHooks/UsePostalCodeValidation";
import { EnrollmentRegisterServiceReset } from "../../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice";
import { getCountryCode } from "../../../../utils/Internationalization/handleAppInternationalization";

const DeviceConfig = (props) => {
  const {
    editDeviceDetail = false,
    deviceData = null
  } = props;

  const { t } = useTranslation(["translation"]);
  const dispatch = useDispatch();
  const history = useHistory();
  const countryCode = getCountryCode();
  const countryName = getCountryName(countryCode);  

  var DeviceModel, serialNumber = '';
  if (editDeviceDetail) {
    DeviceModel = deviceData?.model || getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
    serialNumber = deviceData?.serialNumber || getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER);
  }
  else {
    DeviceModel = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
    serialNumber = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.SERIAL_NUMBER);
  }
  const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
  const [openAddressEditForm, setOpenAddressEditForm] = useState(false);
  const [location, setLocation] = useState(
    (editDeviceDetail && deviceData?.addressId && deviceData?.addressId !== 0)
      ? deviceData?.addressId
      : "");
  const [errors, setErrors] = useState({});
  const [printerImg, setPrinterImg] = useState(null);
  const { addressData } = useSelector((state) => state.ROOTREDUCER_RTK.getUserAddress);
  const { shippingAddress: shippingAddressList } = addressData || {};
  const getDevicesResponse = useSelector((state => state.BROTHERPLUS.getDevices));
  const UpdateEnrolledDeviceDetailsResp = useSelector((state => state.ROOTREDUCER_RTK.UpdateUserEnrolledDeviceDetails))
  const [deviceName, setDeviceName] = useState((editDeviceDetail && deviceData?.deviceName)
    ? deviceData?.deviceName
    : DeviceModel || "");

  const [address, setAddress] = useState(null);

  const {
    postcodeLoader,
    validatePostalCode
  } = UsePostalCodeValidation(address?.country, address?.postCode)

  const requiredAddressFields = ['addressName', 'addressLine1', 'cityTown', 'country', 'postCode'];
  const { validateAddress } = useAddressValidation(address, requiredAddressFields);

  useEffect(() => {
    dispatch(getUserAddressRequest())
    dispatch(getDevicesRequest({ userId }))
  }, [dispatch, userId]);

  useEffect(() => {
    if (getDevicesResponse?.devices?.devices.length > 0) {
      const devicesArr = getDevicesResponse?.devices?.devices;
      const printerImg = findValueByKey_From_ArrayOfObj(devicesArr, 'serialNumber', serialNumber, 'imagePath');
      setPrinterImg(printerImg);
    }
  }, [getDevicesResponse?.devices?.devices, serialNumber]);

  useEffect(() => {
    if (UpdateEnrolledDeviceDetailsResp?.success) {
      const timer = setTimeout(() => {
        history.push(routePath.MY_DEVICES);
      }, 3000);

      // reset brother plus registerService state
      dispatch(EnrollmentRegisterServiceReset());

      return () => clearTimeout(timer);
    }
  }, [dispatch, UpdateEnrolledDeviceDetailsResp?.success, history]);

  // set default address value of address when edit button is clicked
  useEffect(() => {
    setAddress(editDeviceDetail && shippingAddressList?.length > 0 && deviceData?.addressId && deviceData?.addressId !== 0
      ? shippingAddressList?.filter(addr => addr.addressId === parseInt(deviceData?.addressId))[0] || null
      : null)
  }, [deviceData?.addressId, editDeviceDetail, shippingAddressList]);

  const handleChange = (e) => {
    const value = e.target.value;
    setDeviceName(value);
  };

  async function handleContinue() {
    const deviceDetails = {
      "deviceName": deviceName,
      "deviceAddress": address,
      "editDeviceDetail": editDeviceDetail
    }

    let validationErrors = {};
    if (openAddressEditForm) {
      validationErrors = await validateAddress();
    }
    if (deviceName !== undefined && !deviceName.trim()) {
      validationErrors.deviceName = 'This field is required';
    }
    const isPostalcodeNotValid = await validatePostalCode();
    if (isPostalcodeNotValid) {
      validationErrors['postCode'] = t("FORM_CONTENT.FORM_ERROR.POSTCODE_VALID")
    }

    if (Object.keys(validationErrors).length === 0) {
      dispatch(updateEnrolledDeviceRequest(deviceDetails));
    } else {
      setErrors(validationErrors);
    }
  }

  const handleAddresDropDown = (e) => {
    const value = e.target.value;
    setLocation(value);
    if (value === 'add_new') {
      setLocation("");
      setAddress({ country: countryName })
      setErrors({});
      setOpenAddressEditForm(true);
    } else if (value === 'default_select') {
      setAddress(null);
    } else {
      setOpenAddressEditForm(false);
      const selectedAddres = shippingAddressList?.find(
        (addr) => addr.addressId === parseInt(value)
      ) || null;
      setAddress(selectedAddres);
    }
  }

  if (getDevicesResponse.loading) {
    return <Loader />
  }

  return (
    <div className="device-config-container">
      {
        (UpdateEnrolledDeviceDetailsResp?.error)
          ? <div className="device-not-connected-wrapper">
            <ErrorPage errorInfo={UpdateEnrolledDeviceDetailsResp.error} webConnectionDashboardError={true} />
          </div>
          : <>
            {
              (UpdateEnrolledDeviceDetailsResp?.loading)
              &&
              <div className="device-not-connected-wrapper">
                <div className={`add-device-device-config loader-overlay-wrapper`}>
                  <Loader webConnection={true} setOverlay={true}></Loader>
                </div>
              </div>
            }
            {
              (UpdateEnrolledDeviceDetailsResp?.success)
              &&
              <div className="add-device-device-config-success-wrapper device-not-connected-wrapper web-connect-section">
                <div className='spinner-wrapper apply-overlay-bg device-successfully-connected'>
                  <img src={DeviceConnectedSuccessfullyImage} alt="device-successfully-connected"></img>
                  <div>{editDeviceDetail ? t("MANAGE_ADDRESS.ADDRESS_UPDATE_SUCCESS") : t("WEB_CONNECTION.CONNECTION_SUCCESS")}</div>
                </div>
              </div>
            }
            <>
              <div className="top-section-device-config">
                <div className="top-text">
                  {t("MY_DEVICES.DEVICE_CONFIG.SET_DEVICE_NAME")}
                </div>
              </div>
              <div className="device-content">
                <div className="device-image">
                  <img alt="Device" title="device" src={printerImg || DefaultPrinterImg} />
                </div>
                <div className="device-details">
                  <div className="detail-row device-name">
                    <div className="device-name-container">
                      <label>{t("MY_DEVICES.DEVICE_CARD.DEVICE_NAME")} *</label>
                      <input
                        type="text"
                        name="deviceName"
                        placeholder= {t('DASHBOARD.ENROLLED_DEVICE_SECTION.DEVICE_NAME')}
                        value={deviceName}
                        onChange={handleChange}
                        maxLength={20}
                      />
                    </div>
                    <div className="invalid-feedback display-error">{errors?.deviceName}</div>
                  </div>
                  <div className="detail-row">
                    <label>{t("MY_DEVICES.DEVICE_CONFIG.MODEL_NUMBER")}</label>
                    <div className="detail-value">
                      {DeviceModel}
                    </div>
                  </div>
                  <div className="detail-row">
                    <label>{t("MY_DEVICES.DEVICE_CONFIG.SERIAL_NUMBER")}</label>
                    <div className="detail-value">
                      {serialNumber}
                    </div>
                  </div>
                  <div className="detail-row">
                    {openAddressEditForm ?
                      <>
                        <AddAddress
                          handleContinue={handleContinue}
                          setOpenAddressEditForm={setOpenAddressEditForm}
                          address={address}
                          setAddress={setAddress}
                          errors={errors}
                          isPostcodeLoading={postcodeLoader}
                        />
                      </> :
                      <>
                        <label>{t("MY_DEVICES.DEVICE_CONFIG.DEVICE_LOCATION")}</label>
                        <div className="detail-value">
                          <select
                            value={location}
                            onChange={handleAddresDropDown}
                          >
                            <option value="default_select">{t("MY_DEVICES.DEVICE_CONFIG.SELECT_AN_ADDRESS")}</option>
                            {shippingAddressList?.length > 0 && shippingAddressList?.map((addr, index) => (
                              <option key={index} value={addr.addressId}>
                                {addr.addressName || truncateString(addr.addressLine1)}
                              </option>
                            ))}
                            <option value="add_new" style={{ color: "blue", cursor: "pointer", fontSize: "14px" }}>
                              {t("MY_DEVICES.DEVICE_CONFIG.ADD_NEW_ADDRESS")}
                            </option>
                          </select>
                        </div>
                      </>
                    }

                  </div>
                </div>
              </div>
              <div className="continue-button">
                {!openAddressEditForm && <button onClick={handleContinue}>{t("MY_DEVICES.DEVICE_CONFIG.CONTINUE_BUTTON")}</button>}

              </div>
            </>
          </>
      }
    </div>
  );
}

export default DeviceConfig;